import Enumerable from "linq";
import { FixedPhraseReference } from ".";
import { Directory } from "../drawing";

export class FixedPhraseRootReference {
  constructor(
    public tableId: string,
    public templateId: string,
    public folders: Directory<number, FixedPhraseReference>[]) {
  }

  clone() {
    return new FixedPhraseRootReference(
      this.tableId,
      this.templateId,
      Enumerable.from(this.folders)
        .select(d => d.clone())
        .toArray()
    );
  }
}
